/**
 * TanStack Query hooks for `csv-xlsx-attachment-on-scheduled-report`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	csvXlsxAttachmentOnScheduledReportQueryKeys,
	type CreateCsvXlsxAttachmentOnScheduledReportBody,
	type ListCsvXlsxAttachmentOnScheduledReportResponse,
	type CsvXlsxAttachmentOnScheduledReportRow,
} from "./api";

export function useCsvXlsxAttachmentOnScheduledReportList(): UseQueryResult<ListCsvXlsxAttachmentOnScheduledReportResponse, Error> {
	return useQuery({
		queryKey: csvXlsxAttachmentOnScheduledReportQueryKeys.list(),
		queryFn: list,
	});
}

export function useCsvXlsxAttachmentOnScheduledReportCreate(): UseMutationResult<CsvXlsxAttachmentOnScheduledReportRow, Error, CreateCsvXlsxAttachmentOnScheduledReportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: csvXlsxAttachmentOnScheduledReportQueryKeys.all });
		},
	});
}

export function useCsvXlsxAttachmentOnScheduledReportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: csvXlsxAttachmentOnScheduledReportQueryKeys.all });
		},
	});
}
